export default "__VITE_ASSET__CZ2ZImiS__"